import AbstractValidator from './AbstractValidator';

export default class PhoneNumber extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        numberNotMatch: 'Bitte geben Sie eine gültige Telefonnummer an.',
    };

    run()
    {
        let test = new RegExp(/^(\+ *\d+)?( *(\d+|\d+ *[/-] *\d+|\(\d+\)) *)+$/);

        if (!test.test(this.value))
        {
            this.error = this.getMessage('numberNotMatch');
        }
    }
}